import {Article} from 'api'
import {useArticlesTree} from './useArticles'

export default function usePinnedArticles(): Article[] {
  const tree = useArticlesTree()

  return tree.flatFilter(a => a.pinned)
}
